import React, { useCallback, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { modalEventListener } from "../../../utils/ModalEventListener";
import { axios_instance } from "../../../api/axios_instance";
import RadioButtons from "../../../layouts/RadioButtons";
import SingleSelectDropDown from "../../../layouts/SingleSelectDropDown";
import {
  fetchPayeeDetails,
  ifscMapping,
  payeeBalTotal,
  validatePayeeDetails,
} from "../../../utils/withheldtable";
import LoadingModal from "../../../layouts/LoadingModal";
import {
  decryptRequest,
  encryptRequest,
} from "../../../utils/encryptdecryptrequest";
import ModalWrapper from "../../../layouts/ModalWrapper";

const PayeeDetailsModal = ({
  payeeDetailProps,
  fetchListData,
  closePayeeDetailsModal,
  showPayeeDetailsModal,
}) => {
  const [state, setState] = useState({
    payeeData: {},
    inputsDisabled: false,
  });

  const [dropwDownData, setDropdownData] = useState({
    payeeTypeList: [],
    payerAccount: [],
  });

  const [isLoading, setIsLoading] = useState(false);
  const ref = useRef();

  useEffect(() => {
    return modalEventListener(ref, closePayeeDetailsModal);
  }, [closePayeeDetailsModal]);

  const fetchData = async () => {
    setIsLoading(true);

    try {
      const reqData = encryptRequest({
        finance_lead_id: payeeDetailProps.finance_lead_id,
        sub_stage: payeeDetailProps.sub_stage,
      });
      const payeeResult = await axios_instance({
        url: "/wp/getPayeeData",
        method: "POST",
        data: { reqData },
      });

      if (payeeResult.status === 200) {
        const decryptedData = decryptRequest(payeeResult.data.resData);
        setState((prevState) => ({
          ...prevState,
          payeeData: decryptedData.payeeData,
          inputsDisabled: decryptedData.inputsDisabled,
        }));

        setDropdownData((prevState) => ({
          ...prevState,
          payeeTypeList: decryptedData.payeeTypeList,
          payerAccount: decryptedData.payerAccount,
        }));
      }
    } catch (error) {
      //Handle error
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (showPayeeDetailsModal) fetchData();
  }, [showPayeeDetailsModal]);

  const handleInputChange = async (inputName, value) => {
    if (inputName === "payee_type") {
      state.payeeData[inputName] = value;
      await fetchPayeeDetails(state, setState);
      return;
    }
    setState({
      ...state,
      payeeData: { ...state.payeeData, [inputName]: value },
    });
  };

  const saveWithheldPayeeDetails = async () => {
    if (!validatePayeeDetails(state, setState)) return;
    if (+state.payeeData.disburse_paid_amt > +state.payeeData.rto_charges) {
      return window.alert(
        "You cannot release higher RTO Charges than Withheld Amount through this panel, please visit the case and create tranche manually"
      );
    }

    try {
      await axios_instance({
        url: "/wp/savePayeeDetails",
        method: "POST",
        data: {
          ...state.payeeData,
          stage: 1,
          sub_stage: 2,
          action: "save_payee_details",
        },
      });
      await fetchListData(true, false, payeeDetailProps.finance_lead_id);
    } catch (error) {}
  };

  return ReactDOM.createPortal(
    <ModalWrapper show={showPayeeDetailsModal} onClose={closePayeeDetailsModal}>
      {" "}
      <div className="modal-wrapper">
        {isLoading && <LoadingModal />}
        <div className="payee-details-modal-content" id="new-popupst" ref={ref}>
          <form id="payee-detail-frm" name="payee-detail-frm">
            <input
              type="hidden"
              name="finance_lead_id"
              value={state.payeeData.finance_lead_id}
              readOnly
            />
            <input
              type="hidden"
              name="disbursement_id"
              value={state.payeeData.disbursement_id}
              readOnly
            />
            <input
              type="hidden"
              name="pay_count"
              value={state.payeeData.dts_pay_count}
            />
            <input
              type="hidden"
              id="rto_charges"
              name="rto_charges"
              value={state.payeeData.rto_charges}
              readOnly
            />
            <input
              type="hidden"
              id="is_process_by_withheld"
              name="is_process_by_withheld"
              value={state.payeeData.is_process_by_withheld}
              readOnly
            />

            <div className="modal-header">
              <button
                name="close_payee_popup"
                className="close"
                aria-label="Close"
                onClick={closePayeeDetailsModal}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 className="modal-title" id="">
                Payee Details
              </h4>
            </div>

            <div className="modal-body clearfix">
              <div className="form-group clearfix">
                <div className="row">
                  <div className="col-md-5 text-right">
                    <label className="fnt14">Disbursing Bank</label>
                  </div>
                  <div className="col-md-6">{state.payeeData.bank_name}</div>
                </div>
              </div>

              <div className="form-group clearfix">
                <div className="row">
                  <div className="col-md-5 text-right">
                    <label className="fnt14">RTO Agent</label>
                  </div>
                  <div className="col-md-6">{state.payeeData.rcAgentName}</div>
                </div>
              </div>

              <div className="form-group clearfix">
                <div className="row">
                  <div className="col-md-5 text-right">
                    <label className="fnt14">Float Payment</label>
                  </div>
                  <div className="col-md-6">
                    <RadioButtons
                      label=""
                      isRequired={false}
                      className={`btn tog-btn tog-positive  float-pay  ${
                        parseInt(
                          state.payeeData.is_payment_received_by_bank
                        ) === 1
                          ? "active"
                          : ""
                      }`}
                      name="is_payment_received_by_bank"
                      disabled={state.inputsDisabled}
                      yesChecked={
                        parseInt(
                          state.payeeData.is_payment_received_by_bank
                        ) === 1
                      }
                      noChecked={
                        parseInt(
                          state.payeeData.is_payment_received_by_bank
                        ) === 0
                      }
                      noButtonClassName={`btn tog-btn tog-negative  float-pay  ${
                        parseInt(
                          state.payeeData.is_payment_received_by_bank
                        ) === 0
                          ? "active"
                          : ""
                      }
                    `}
                      showDiv={true}
                      DivClassName="btn-group toggle-option"
                      isStyledButton={true}
                      onYesClicked={() =>
                        handleInputChange("is_payment_received_by_bank", 1)
                      }
                      onNoClicked={() =>
                        handleInputChange("is_payment_received_by_bank", 0)
                      }
                      hideTd={true}
                    />
                  </div>
                </div>
              </div>

              <div className="form-group clearfix">
                <div className="row">
                  <div className="col-md-5 text-right">
                    <label className="fnt14">Payment Mode</label>
                  </div>
                  <div className="col-md-6">
                    <div
                      id="payment_mode_grp"
                      className="btn-group toggle-option"
                      data-toggle="buttons"
                    >
                      <label
                        className="btn tog-btn tog-negative  pay-mode active"
                        disabled={state.inputsDisabled}
                      >
                        <input
                          type="radio"
                          name="payment_mode"
                          value="NEFT"
                          onChange={() => {}}
                          disabled={state.inputsDisabled}
                        />
                        NEFT
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-group clearfix">
                <div className="row">
                  <div className="col-md-5 text-right">
                    <label className="fnt14">
                      Payee Type <span className="col-red">*</span>
                    </label>
                  </div>
                  <div className="col-md-6">
                    <SingleSelectDropDown
                      dataArr={dropwDownData.payeeTypeList}
                      name="payee_type"
                      disabled={state.inputsDisabled}
                      required={true}
                      value={state.payeeData.payee_type}
                      handleChange={(e) =>
                        handleInputChange("payee_type", e.target.value)
                      }
                      divClassName={`form-group ${state.payeeData.payee_type_Class}`}
                    />
                    <div className="errorTxt" id="error_payee_type">
                      {state.payeeData.error_payee_type_Msg}
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-group clearfix">
                <div className="row">
                  <div className="col-md-5 text-right">
                    <label className="fnt14">
                      Payee Name <span className="col-red">*</span>
                    </label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      value={state.payeeData.payee_name}
                      id="payee_name"
                      name="payee_name"
                      placeholder="Enter Name"
                      title="correct"
                      pattern="^[a-zA-Z][a-zA-Z ]{2,}$"
                      onChange={(e) =>
                        handleInputChange("payee_name", e.target.value)
                      }
                      disabled={state.inputsDisabled}
                      className={`form-control ${state.payeeData.payee_name_Class}`}
                    />
                    <div className="errorTxt" id="error_payee_name">
                      {state.payeeData.error_payee_name_Msg}
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-group clearfix">
                <div className="row">
                  <div className="col-md-5 text-right">
                    <label className="fnt14">
                      Payee Account Number <span className="col-red">*</span>
                    </label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      value={state.payeeData.payee_ac_number}
                      id="payee_ac_number"
                      name="payee_ac_number"
                      placeholder="Enter Account Number"
                      onChange={(e) =>
                        handleInputChange("payee_ac_number", e.target.value)
                      }
                      disabled={state.inputsDisabled}
                      className={`form-control ${state.payeeData.payee_ac_number_Class}`}
                    />
                    <div className="errorTxt" id="error_payee_ac_number">
                      {state.payeeData.error_payee_ac_number_Msg}
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-group clearfix">
                <div className="row">
                  <div className="col-md-5 text-right">
                    <label className="fnt14">
                      IFSC Code <span className="col-red">*</span>
                    </label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      value={state.payeeData.payee_ifsc_code?.toUpperCase()}
                      name="payee_ifsc_code"
                      id="payee_ifsc_code"
                      maxLength="11"
                      placeholder="Enter IFSC Code"
                      onChange={(e) =>
                        handleInputChange("payee_ifsc_code", e.target.value)
                      }
                      disabled={state.inputsDisabled}
                      className={`form-control ${state.payeeData.payee_ifsc_code_Class}`}
                      onBlur={() => ifscMapping(state, setState)}
                    />
                    <div className="errorTxt" id="error_payee_ifsc_code">
                      {state.payeeData.error_payee_ifsc_code_Msg}
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-group clearfix">
                <div className="row">
                  <div className="col-md-5 text-right">
                    <label className="fnt14">
                      Bank Name <span className="col-red">*</span>
                    </label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      value={state.payeeData.payee_bank_name}
                      id="payee_bank_name"
                      name="payee_bank_name"
                      placeholder="Enter Bank Name"
                      onChange={(e) =>
                        handleInputChange("payee_bank_name", e.target.value)
                      }
                      disabled={state.inputsDisabled}
                      className={`form-control ${state.payeeData.payee_bank_name_Class}`}
                    />
                    <div className="errorTxt" id="error_payee_bank_name">
                      {state.payeeData.error_payee_bank_name_Msg}
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-group clearfix">
                <div className="row">
                  <div className="col-md-5 text-right">
                    <label className="fnt14">
                      Branch Name <span className="col-red">*</span>
                    </label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      value={state.payeeData.payee_branch_name}
                      name="payee_branch_name"
                      id="payee_branch_name"
                      placeholder="Enter Branch Name"
                      onChange={(e) =>
                        handleInputChange("payee_branch_name", e.target.value)
                      }
                      disabled={state.inputsDisabled}
                      className={`form-control ${state.payeeData.payee_branch_name_Class}`}
                    />
                    <div className="errorTxt" id="error_payee_branch_name">
                      {state.payeeData.error_payee_branch_name_Msg}
                    </div>
                  </div>
                </div>
              </div>

              <input
                type="hidden"
                id="disburse_payable_amt"
                name="disburse_payable_amt"
                value={
                  state.payeeData.disburse_payable_amt
                    ? parseInt(state.payeeData.disburse_payable_amt)
                    : "0"
                }
                readOnly
              />
              <div className="form-group clearfix">
                <div className="row">
                  <div className="col-md-5 text-right">
                    <label className="fnt14">Tranche Amount</label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className={`form-control ${state.payeeData.disburse_paid_amt_class}`}
                      id="disburse_paid_amt"
                      name="disburse_paid_amt"
                      value={
                        state.payeeData.disburse_paid_amt
                          ? parseInt(state.payeeData.disburse_paid_amt)
                          : "0"
                      }
                      placeholder="Enter Tranche Amount"
                      onChange={(e) =>
                        handleInputChange("disburse_paid_amt", e.target.value)
                      }
                      disabled={state.inputsDisabled}
                      onKeyUp={() => payeeBalTotal(state, setState)}
                    />
                    <div
                      className="errorTxt"
                      id="error_disburse_paid_amt"
                    ></div>
                  </div>
                </div>
              </div>
              <input
                type="hidden"
                id="disburse_bal_amt"
                name="disburse_bal_amt"
                value={
                  state.payeeData.disburse_bal_amt
                    ? parseInt(state.payeeData.disburse_bal_amt)
                    : "0"
                }
                readOnly
              />

              <div className="form-group clearfix">
                <div className="row">
                  <div className="col-md-5 text-right">
                    <label className="fnt14">Payer Account</label>
                  </div>
                  <div className="col-md-6">
                    <SingleSelectDropDown
                      dataArr={dropwDownData.payerAccount}
                      name="payable_ac_number"
                      disabled={state.inputsDisabled}
                      required={true}
                      value={state.payeeData.payable_ac_number}
                      handleChange={(e) =>
                        handleInputChange("payable_ac_number", e.target.value)
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer text-center">
              <button
                type="button"
                className="btn rc-btn_primary pad-tb"
                onClick={saveWithheldPayeeDetails}
                disabled={state.inputsDisabled}
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </ModalWrapper>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default PayeeDetailsModal;
